import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { Sort } from '@angular/material/sort';
import { TableStyle } from 'src/app/models/enums/tableStyle';
import { BonusContinuaService } from 'src/app/core/services/tables/bonus-continua.service';
import { BonusContinuaStore } from 'src/app/core/services/tables/bonus-continua.store';
import { InfoService } from '../../../core/services/tables-info/info.service';
import { DialogService } from 'src/app/core/services/dialog.service';
import { AuthService } from 'src/app/core/services/user-services/auth.service';
import { Helpers } from 'src/app/models/Helpers/helpers';
import {Loader} from '../../../models/Helpers/loader';
import {AddToWatchlistManagerService} from '../../../core/services/watchlists/add-to-watchlist-manager.service';

@Component({
  selector: 'app-bonus-continua-table',
  templateUrl: './bonus-continua-table.component.html',
  styleUrls: ['./bonus-continua-table.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: 0, padding: 0 })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('0.3s cubic-bezier(0.77, 0, 0.175, 1)'))
    ]),
  ]
})
export class BonusContinuaTableComponent implements OnInit {
  @Input() style: TableStyle;
  @Input() totalPages;
  @Input() pageNumber;
  @Input() pageSize;
  @Input() state;
  @Input() showLoader;

  @Output() getData: EventEmitter<any> = new EventEmitter<any>();
  @Output() updatePageSize: EventEmitter<any> = new EventEmitter<any>();

  tableTitle = 'Bonus Continua';
  tableStyle = TableStyle;
  isAlreadyFetched: boolean;
  filter: string;
  ascending: boolean;
  isGuest = false;
  tableInfoExists: boolean;
  userIsAdmin: boolean;
  userIsProfessional: boolean;
  downloadExcelLoader = new Loader();

  constructor(
    private service: BonusContinuaService,
    public store: BonusContinuaStore,
    private infoService: InfoService,
    private dialogService: DialogService,
    private userService: AuthService,
    private addToWatchlistManager: AddToWatchlistManagerService
    ) {
    this.userIsAdmin = this.userService.user?.profile?.role === 'CedLabAdmin';
    this.userIsProfessional = ['CedLabProfessional', 'CedLabPowerUser'].includes(this.userService.user?.profile?.role);
    this.userService.userManager.getUser().then(
      user => this.isGuest = user?.profile?.role === 'CedLabGuest'
    );
  }

  ngOnInit(): void {
    this.tableInfoExists = this.infoService.isThereInfo(this.tableTitle);
    this.isAlreadyFetched = this.state === 'expanded';
  }

  localeCurrency(currency: string) {
    return Helpers.getCurrencyLocale(currency);
  }
  currencySymbol(currency: string) {
    return Helpers.getCurrencySymbol(currency);
  }

  getRecords(pageNumber: number) {
    this.getData.emit({ pageNumber, filter: this.filter, ascending: this.ascending });
    this.isAlreadyFetched = true;
  }

  deepSortRecords({ active, direction }) {
    this.filter = active;
    this.ascending = direction === 'asc' ? true : direction === 'desc' ? false : null;
    this.getData.emit({ pageNumber: this.pageNumber, filter: this.filter, ascending: this.ascending });
  }


  toggle() {
    this.state = this.state === 'collapsed' ? 'expanded' : 'collapsed';
    if (!this.isAlreadyFetched) {
      this.getRecords(this.pageNumber);
    }
    this.isAlreadyFetched = true;
  }

  nextPage() {
    ++this.pageNumber;
    this.getRecords(this.pageNumber);
  }

  previousPage() {
    --this.pageNumber;
    this.getRecords(this.pageNumber);
  }

  firstPage() {
    this.pageNumber = 1;
    this.getRecords(this.pageNumber);
  }

  lastPage() {
    this.pageNumber = this.totalPages;
    this.getRecords(this.pageNumber);
  }

  updateSize(event: any) {
    this.updatePageSize.emit({ event, filter: this.filter, ascending: this.ascending });
  }


  sendSortingParam(sort: Sort) {
    this.service.sorting(sort);
  }

  sendSortingParamGuest(sort: Sort) {
    this.service.sortingGuestRecords(sort);
  }

  openDialog() {
    const tableInfo = this.infoService.getTableInfo(this.store.title);
    this.dialogService.openTableInfoDialog(tableInfo);
  }

  addToWatchlist(isin: string) {
    if (this.isGuest) {
      this.dialogService.openFailureSnackBar('Abbonati ai servizi CedLab per usufruire dell\'esperienza completa');
      return;
    }

    this.addToWatchlistManager.addToWatchlist(isin);
  }

  public async downloadExcel() {
    this.downloadExcelLoader.show();
    await this.service.downloadExcel(50).then(
      response => {
        const currentDate = new Date();
        const fileName = 'BonusContinuaTop50_' + (currentDate.getMonth() + 1) + '_' + currentDate.getFullYear();
        const a = document.createElement('a');
        const objectUrl = URL.createObjectURL(response);
        a.href = objectUrl;
        a.download = fileName;
        a.click();
        URL.revokeObjectURL(objectUrl);
      }).catch(_ => {
      this.dialogService.openFailureSnackBar('Errore nel download');
    });
    this.downloadExcelLoader.hide();
  }
}
